import { render } from "./UnderRecruitmentProfile.vue?vue&type=template&id=d3c5f1f6&scoped=true"
import script from "./UnderRecruitmentProfile.vue?vue&type=script&lang=js"
export * from "./UnderRecruitmentProfile.vue?vue&type=script&lang=js"

import "./UnderRecruitmentProfile.vue?vue&type=style&index=0&id=d3c5f1f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3c5f1f6"]])

export default __exports__